type JsonLdNestedValue =
    | string
    | number
    | boolean
    | null
    | undefined
    | JsonLdNestedValue[]
    | { [key: string]: JsonLdNestedValue };

type JsonLdRootValue = Exclude<JsonLdNestedValue, undefined>;

export function toJsonLdScriptContent(value: JsonLdRootValue): string {
    return JSON.stringify(value)
        .replace(/&/g, "\\u0026")
        .replace(/</g, "\\u003c")
        .replace(/>/g, "\\u003e")
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029");
}
